<template>
  <div class="toastWr d-flex justify-content-center">
    <div class="container">
      <div class="toast" role="alert" aria-live="assertive" aria-atomic="true" v-bind:data-delay="delay">
        <div class="toast-header">
          <p>{{text}}</p>
          <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FrontendToaster',
  props: {
    text: { type: String, required: true },
    delay: { type: Number, default: 300, required: true }
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/partials/toaster.vue